import React, { useState, useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTodasAreas, createCliente, getServiciosPorAreaCliente, asignarServiciosACliente, getServiciosPorAreas } from '../../actions/index.js';
import axiosClient from '../../axiosClient.js';
import Select from 'react-select';
import swal from 'sweetalert';
import { logger } from '../../utils/logger.js';
import './CrearCliente.css';

// react-select (multi) con la paleta moderna oscura + verde
const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#0A100D',
    borderColor: state.isFocused ? 'rgba(40,199,111,0.6)' : 'rgba(255,255,255,0.10)',
    borderWidth: '0.5px', borderRadius: '10px', color: '#E8EFEA', minHeight: '42px',
    boxShadow: state.isFocused ? '0 0 0 2px rgba(40,199,111,0.20)' : 'none',
    '&:hover': { borderColor: 'rgba(40,199,111,0.45)' }
  }),
  menu: (provided) => ({ ...provided, backgroundColor: '#0C120F', border: '0.5px solid rgba(40,199,111,0.25)', borderRadius: '11px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.6)', zIndex: 9999 }),
  menuList: (provided) => ({ ...provided, padding: '6px', maxHeight: '230px' }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? 'rgba(40,199,111,0.16)' : state.isFocused ? 'rgba(40,199,111,0.12)' : 'transparent',
    color: state.isSelected || state.isFocused ? '#EAF6EF' : '#CBD6CF', borderRadius: '8px', padding: '9px 11px', cursor: 'pointer',
  }),
  placeholder: (provided) => ({ ...provided, color: '#9FB0A6', fontSize: 13 }),
  input: (provided) => ({ ...provided, color: '#E8EFEA' }),
  valueContainer: (provided) => ({ ...provided, padding: '4px 8px', gap: '4px' }),
  multiValue: (provided) => ({ ...provided, backgroundColor: 'rgba(40,199,111,0.14)', borderRadius: '999px' }),
  multiValueLabel: (provided) => ({ ...provided, color: '#3FE07F', fontSize: 12, padding: '2px 4px 2px 8px' }),
  multiValueRemove: (provided) => ({ ...provided, color: '#3FE07F', borderRadius: '999px', ':hover': { backgroundColor: 'rgba(40,199,111,0.25)', color: '#EAF6EF' } }),
  groupHeading: (provided) => ({ ...provided, color: '#8A988F', fontSize: 11, textTransform: 'none', padding: '6px 8px' }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (provided, state) => ({ ...provided, color: state.isFocused ? '#3FE07F' : '#5C6862', ':hover': { color: '#3FE07F' } }),
  clearIndicator: (provided) => ({ ...provided, color: '#9FB0A6', ':hover': { color: '#E86D6D' } }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const CrearCliente = ({ onClose, onClienteCreado }) => {
  const dispatch = useDispatch();
  const areas = useSelector(state => state.Repoteareas);
  
  // Estados para el formulario
  const [paso, setPaso] = useState(1);
  const [clienteCreado, setClienteCreado] = useState(null);
  const [loading, setLoading] = useState(false);
  
  // Estado para Paso 1 - Datos del cliente
  const [datosCliente, setDatosCliente] = useState({
    nombre: '',
    descripcion: '',
    correo: '',
    numeroContacto: '',
    direccion: '',
    estado: true, // Boolean: true = activo, false = inactivo
    areas: [],
    
  });

  // Estado para Paso 2 - Servicios disponibles
  const [serviciosDisponibles, setServiciosDisponibles] = useState([]);
  const [serviciosSeleccionados, setServiciosSeleccionados] = useState([]);

  // Extraer array de áreas del estado
  const areasArray = areas?.areas || [];

  // Cargar áreas al montar el componente
  useEffect(() => {
    const cargarAreas = async () => {
      try {
        logger.log('Cargando áreas...');
        await dispatch(getTodasAreas());
        logger.log('Áreas cargadas:', areas);
      } catch (error) {
        logger.error('Error al cargar áreas:', error);
        swal("Error", "No se pudieron cargar las áreas", "error");
      }
    };
    cargarAreas();
  }, [dispatch]);

  // Debug: Monitorear cambios en areas
  useEffect(() => {
    logger.log('Areas state cambió:', areas, 'Áreas array:', areasArray);
  }, [areas]);

  // Función auxiliar para obtener nombres de áreas por IDs
  const obtenerNombresAreas = (areaIds) => {
    if (!areasArray || !Array.isArray(areasArray) || !areaIds) return '';
    const nombresAreas = areaIds.map(id => {
      const area = areasArray.find(a => a.id === id);
      return area ? area.nombre : `ID: ${id}`;
    });
    return nombresAreas.join(', ');
  };

  // Preparar opciones para react-select (áreas)
  // Las áreas vienen en formato {areas: [...]} del backend
  const opcionesAreas = (areasArray && Array.isArray(areasArray)) ? areasArray.map(area => ({
    value: area.id, // Usar ID para el backend
    label: area.nombre // Mostrar nombre en el select
  })) : [];

  // Manejar cambios en los inputs del Paso 1
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDatosCliente(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Manejar selección de áreas
  const handleAreasChange = (selectedOptions) => {
    const areasSeleccionadas = selectedOptions ? selectedOptions.map(option => option.value) : []; // IDs de áreas
    setDatosCliente(prev => ({
      ...prev,
      areas: areasSeleccionadas
    }));
  };

  // Crear cliente - Paso 1
  const handleCrearCliente = async (e) => {
    e.preventDefault();
    
    if (!datosCliente.nombre.trim()) {
      swal("Error", "El nombre del cliente es obligatorio", "error");
      return;
    }

    if (datosCliente.areas.length === 0) {
      swal("Error", "Debe seleccionar al menos un área", "error");
      return;
    }

    setLoading(true);
    try {
      const resultado = await dispatch(createCliente(datosCliente));
      
      if (resultado && resultado.success) {
        setClienteCreado(resultado.data.cliente);
        
        // Esperar un momento para que se procesen las relaciones en la BD
        await new Promise(resolve => setTimeout(resolve, 500));
        
        // Esperar un momento para que se procesen las relaciones en la BD
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        try {
          // DEBUG: Verificar qué cliente se creó
          console.log('🔍 Cliente creado:', resultado.data.cliente);
          console.log('🔍 ID del cliente:', resultado.data.cliente.id);
          console.log('🔍 Áreas del cliente desde respuesta:', resultado.data.cliente.areas);
          
          // Verificar si el cliente tiene áreas y obtener servicios
          if (resultado.data.cliente.areas && resultado.data.cliente.areas.length > 0) {
            // Intentar cargar servicios usando la ruta corregida
            const servicios = await dispatch(getServiciosPorAreaCliente(resultado.data.cliente.id));
            if (servicios && servicios.length > 0) {
              setServiciosDisponibles(servicios);
              setPaso(2);
              swal("¡Éxito!", "Cliente creado correctamente. Ahora seleccione los servicios.", "success");
            } else {
              swal("¡Éxito!", "Cliente creado correctamente. No hay servicios disponibles para las áreas seleccionadas.", "success");
              onClienteCreado && onClienteCreado(resultado.data.cliente);
              onClose();
            }
          } else {
            swal("¡Éxito!", "Cliente creado correctamente pero sin áreas asignadas.", "success");
            onClienteCreado && onClienteCreado(resultado.data.cliente);
            onClose();
          }
        } catch (serviciosError) {
          console.error('❌ Error completo al cargar servicios:', serviciosError);
          logger.error('Error al cargar servicios, pero cliente creado exitosamente:', serviciosError);
          // Cliente creado exitosamente, pero no se pudieron cargar servicios
          swal("¡Parcialmente exitoso!", "Cliente creado correctamente, pero no se pudieron cargar los servicios. Puede asignarlos posteriormente.", "warning");
          onClienteCreado && onClienteCreado(resultado.data.cliente);
          onClose();
        }
      } else {
        swal("Error", resultado.error || "Error al crear el cliente", "error");
      }
    } catch (error) {
      logger.error('Error al crear cliente:', error);
      swal("Error", "Error al crear el cliente", "error");
    } finally {
      setLoading(false);
    }
  };

  // Manejar selección de servicios
  const handleServiciosChange = (selectedOptions) => {
    if (!selectedOptions) {
      setServiciosSeleccionados([]);
      return;
    }
    
    const serviciosIds = selectedOptions.map(option => {
      // Si el value contiene underscore, es un servicio que viene como string
      if (typeof option.value === 'string' && option.value.includes('_')) {
        // Extraer solo el nombre del servicio (antes del underscore)
        const nombreServicio = option.value.split('_')[0];
        return nombreServicio;
      }
      // Si es un ID numérico normal, usarlo tal como está
      return option.value;
    });
    
    console.log('🔍 Servicios seleccionados (procesados):', serviciosIds);
    setServiciosSeleccionados(serviciosIds);
  };

  // Asignar servicios - Paso 2
  const handleAsignarServicios = async () => {
    if (serviciosSeleccionados.length === 0) {
      swal({
        title: "Sin servicios",
        text: "¿Desea continuar sin asignar servicios?",
        icon: "warning",
        buttons: ["Cancelar", "Continuar"],
        dangerMode: false,
      }).then((continuar) => {
        if (continuar) {
          finalizarCreacion();
        }
      });
      return;
    }

    setLoading(true);
    try {
      console.log('🔍 Enviando servicios al servidor:', serviciosSeleccionados);
      console.log('🔍 Cliente ID:', clienteCreado.id);
      
      const resultado = await dispatch(asignarServiciosACliente(clienteCreado.id, serviciosSeleccionados));
      
      if (resultado && resultado.success) {
        swal("¡Éxito!", "Servicios asignados correctamente al cliente", "success");
        finalizarCreacion();
      } else {
        swal("Error", resultado.error || "Error al asignar servicios", "error");
      }
    } catch (error) {
      logger.error('Error al asignar servicios:', error);
      swal("Error", "Error al asignar servicios", "error");
    } finally {
      setLoading(false);
    }
  };

  // Finalizar creación
  const finalizarCreacion = () => {
    onClienteCreado && onClienteCreado(clienteCreado);
    onClose();
  };

  // Preparar opciones para servicios agrupadas por área
  const opcionesServicios = React.useMemo(() => {
    if (!serviciosDisponibles || !Array.isArray(serviciosDisponibles) || !areasArray) {
      return [];
    }

    // DEBUG: Investigar estructura de servicios
    console.log('🔍 DEBUG serviciosDisponibles:', serviciosDisponibles);
    console.log('🔍 DEBUG areasArray:', areasArray);
    
    if (serviciosDisponibles.length > 0) {
      console.log('🔍 DEBUG primer servicio:', serviciosDisponibles[0]);
      console.log('🔍 DEBUG tipo del primer servicio:', typeof serviciosDisponibles[0]);
      if (typeof serviciosDisponibles[0] === 'object') {
        console.log('🔍 DEBUG claves del primer servicio:', Object.keys(serviciosDisponibles[0]));
      }
    }

    // CASO: Los servicios vienen como objetos con propiedad 'area' o similar
    if (serviciosDisponibles.length > 0 && typeof serviciosDisponibles[0] === 'object') {
      console.log('🔍 Los servicios son objetos, buscando propiedad area...');
      
      const serviciosPorArea = serviciosDisponibles.reduce((acc, servicio) => {
        // DEBUG: Investigar diferentes posibles propiedades para el área
        console.log('🔍 Analizando servicio:', servicio);
        
        let nombreArea = 'Sin área';
        
        // Prioridad 1: Propiedad 'area' directa (nombre del área)
        if (servicio.area && typeof servicio.area === 'string') {
          nombreArea = servicio.area;
          console.log('🔍 Área encontrada en servicio.area:', nombreArea);
        } 
        // Prioridad 2: Objeto Area con nombre
        else if (servicio.Area && servicio.Area.nombre) {
          nombreArea = servicio.Area.nombre;
          console.log('🔍 Área encontrada en servicio.Area.nombre:', nombreArea);
        } 
        // Prioridad 3: Objeto area con nombre (minúscula)
        else if (servicio.area && servicio.area.nombre) {
          nombreArea = servicio.area.nombre;
          console.log('🔍 Área encontrada en servicio.area.nombre:', nombreArea);
        }
        // Prioridad 4: ID de área para buscar en areasArray
        else if (servicio.areaId || servicio.area_id) {
          const areaId = servicio.areaId || servicio.area_id;
          const area = areasArray.find(a => a.id === areaId);
          nombreArea = area ? area.nombre : `Área ID: ${areaId}`;
          console.log('🔍 Área encontrada por ID:', areaId, '→', nombreArea);
        }
        
        if (!acc[nombreArea]) {
          acc[nombreArea] = [];
        }
        
        acc[nombreArea].push({
          value: servicio.id || servicio.nombre, // Usar ID si existe, sino el nombre
          label: servicio.nombre,
          area: nombreArea
        });
        
        console.log(`🔍 Servicio "${servicio.nombre}" → Área "${nombreArea}"`);
        return acc;
      }, {});

      console.log('🔍 Servicios agrupados por área (objetos):', serviciosPorArea);

      // Convertir a formato de grupos para react-select
      return Object.keys(serviciosPorArea).map(nombreArea => ({
        label: nombreArea,
        options: serviciosPorArea[nombreArea].sort((a, b) => a.label.localeCompare(b.label))
      })).sort((a, b) => a.label.localeCompare(b.label));
    }

    // CASO: Los servicios vienen como strings (nombres) - Backend incompleto
    if (serviciosDisponibles.length > 0 && typeof serviciosDisponibles[0] === 'string') {
      console.log('🔍 Los servicios son strings - el backend debe devolver objetos con área');
      console.log('❌ ERROR: El backend debe modificarse para devolver objetos con la propiedad "area"');
      
      // Mostrar todos los servicios en un grupo "Sin área" para que el usuario sepa que hay un problema
      return [{
        label: '⚠️ Sin área - Backend debe incluir información de área',
        options: serviciosDisponibles.map((nombreServicio, index) => ({
          value: `${nombreServicio}_${index}`,
          label: nombreServicio,
          area: 'Sin área'
        })).sort((a, b) => a.label.localeCompare(b.label))
      }];
    }

    return [];
  }, [serviciosDisponibles, areasArray]);

  return (
    <div className="crear-cliente-modal">
      <div className="crear-cliente-container">
        <div className="crear-cliente-header">
          <h2>
            {paso === 1 ? 'Crear Cliente - Paso 1: Datos del Cliente' : 'Crear Cliente - Paso 2: Asignar Servicios'}
          </h2>
          <button className="btn-close" onClick={onClose}>
            <img src={require('../../images/cruz-verde.svg').default} alt="Cerrar" />
          </button>
        </div>

        {paso === 1 ? (
          // PASO 1: Datos del cliente
          <form onSubmit={handleCrearCliente} className="crear-cliente-form">
            <div className="form-group">
              <label htmlFor="nombre">Nombre del Cliente *</label>
              <input
                type="text"
                id="nombre"
                name="nombre"
                value={datosCliente.nombre}
                onChange={handleInputChange}
                placeholder="Ingrese el nombre del cliente"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="descripcion">Descripción</label>
              <textarea
                id="descripcion"
                name="descripcion"
                value={datosCliente.descripcion}
                onChange={handleInputChange}
                placeholder="Descripción del cliente (opcional)"
                rows="3"
              />
            </div>

            <div className="form-group">
              <label htmlFor="correo">Correo Electrónico</label>
              <input
                type="email"
                id="correo"
                name="correo"
                value={datosCliente.correo}
                onChange={handleInputChange}
                placeholder="correo@ejemplo.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="numeroContacto">Número de Contacto</label>
              <input
                type="tel"
                id="numeroContacto"
                name="numeroContacto"
                value={datosCliente.numeroContacto}
                onChange={handleInputChange}
                placeholder="Número de teléfono"
              />
            </div>

            <div className="form-group">
              <label htmlFor="direccion">Dirección</label>
              <input
                type="text"
                id="direccion"
                name="direccion"
                value={datosCliente.direccion}
                onChange={handleInputChange}
                placeholder="Dirección del cliente"
              />
            </div>

            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  name="estado"
                  checked={datosCliente.estado}
                  onChange={(e) => setDatosCliente(prev => ({
                    ...prev,
                    estado: e.target.checked
                  }))}
                />
                Cliente activo
              </label>
            </div>

            <div className="form-group">
              <label>Áreas *</label>
              {process.env.NODE_ENV === 'development' && (
                <div style={{fontSize: '12px', color: '#666', marginBottom: '5px'}}>
                  Debug - Areas disponibles: {areasArray.length}, Seleccionadas: {datosCliente.areas.length}
                </div>
              )}
              <Select
                isMulti
                options={opcionesAreas}
                onChange={handleAreasChange}
                placeholder="Seleccione las áreas del cliente"
                value={opcionesAreas.filter(option => datosCliente.areas.includes(option.value))}
                className="react-select-container"
                classNamePrefix="repms"
                isDisabled={!areasArray || areasArray.length === 0}
                loadingMessage={() => "Cargando áreas..."}
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={customSelectStyles}
              />
            </div>

            <div className="form-actions">
              <button type="button" onClick={onClose} className="btn-cancelar">
                Cancelar
              </button>
              <button type="submit" disabled={loading} className="btn-crear">
                {loading ? 'Creando...' : 'Crear Cliente'}
              </button>
            </div>
          </form>
        ) : (
          // PASO 2: Asignar servicios
          <div className="asignar-servicios-form">
            <div className="cliente-info">
              <h3>Cliente creado: {clienteCreado?.nombre}</h3>
              <p>Áreas seleccionadas: {obtenerNombresAreas(datosCliente.areas)}</p>
            </div>

            <div className="form-group">
              <label>Servicios Disponibles</label>
              <Select
                isMulti
                options={opcionesServicios}
                onChange={handleServiciosChange}
                placeholder="Seleccione los servicios para el cliente (agrupados por área)"
                className="react-select-container"
                classNamePrefix="repms"
                menuPortalTarget={document.body}
                menuPosition="fixed"
                styles={customSelectStyles}
                formatGroupLabel={(data) => (
                  <div className="react-select-group-label">
                    <strong>{data.label}</strong>
                    <span className="react-select-group-badge">{data.options.length}</span>
                  </div>
                )}
              />
            </div>

            <div className="servicios-count">
              <p>Servicios disponibles: {serviciosDisponibles.length}</p>
              <p>Servicios seleccionados: {serviciosSeleccionados.length}</p>
              {serviciosSeleccionados.length > 0 && (
                <div className="servicios-seleccionados-detalle">
                  <h4>Servicios seleccionados:</h4>
                  <ul>
                    {serviciosSeleccionados.map((servicioId, index) => {
                      // Determinar si los servicios son strings o objetos
                      const esString = serviciosDisponibles.length > 0 && typeof serviciosDisponibles[0] === 'string';
                      
                      if (esString) {
                        // Si son strings, el servicioId es el nombre del servicio
                        const nombreServicio = servicioId;
                        // Encontrar en qué área está distribuido
                        const flatOptions = opcionesServicios.flatMap(grupo => 
                          grupo.options.map(opt => ({ ...opt, grupoArea: grupo.label }))
                        );
                        const servicioEncontrado = flatOptions.find(opt => 
                          opt.label === nombreServicio
                        );
                        const nombreArea = servicioEncontrado?.grupoArea || 'Sin área';
                        
                        return (
                          <li key={`${servicioId}_${index}`}>
                            <strong>{nombreServicio}</strong> - {nombreArea}
                          </li>
                        );
                      } else {
                        // Lógica original para objetos
                        const servicio = serviciosDisponibles.find(s => s.id === servicioId);
                        if (!servicio) return null;
                        
                        // Buscar área usando la misma lógica que en el agrupamiento
                        let areaId = servicio.areaId || servicio.area_id || servicio.Area?.id || servicio.area?.id;
                        let nombreArea = 'Sin área';
                        
                        if (areaId) {
                          const area = areasArray.find(a => a.id === areaId);
                          nombreArea = area ? area.nombre : `Área ID: ${areaId}`;
                        } else if (servicio.Area && servicio.Area.nombre) {
                          nombreArea = servicio.Area.nombre;
                        } else if (servicio.area && servicio.area.nombre) {
                          nombreArea = servicio.area.nombre;
                        }
                        
                        return (
                          <li key={servicioId}>
                            <strong>{servicio?.nombre}</strong> - {nombreArea}
                          </li>
                        );
                      }
                    })}
                  </ul>
                </div>
              )}
            </div>

            <div className="form-actions">
              <button 
                type="button" 
                onClick={() => setPaso(1)} 
                className="btn-volver"
              >
                Volver
              </button>
              <button 
                type="button" 
                onClick={handleAsignarServicios} 
                disabled={loading}
                className="btn-asignar"
              >
                {loading ? 'Asignando...' : 'Agregar Servicios'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(CrearCliente);
